





































































import OtButton from '@/components/global/ot-button.vue';
import OtLoadingSpinner from '@/components/global/ot-loading-spinner.vue';
import OtRadioGroup from '@/components/global/ot-radio-group.vue';
import OtTableHeader from '@/components/global/table/ot-table-header.vue';
import { IColumnData } from '@/components/global/table/ot-table-models';
import { handleHeaderClick } from '@/components/global/table/ot-table-utils';
import OtTable from '@/components/global/table/ot-table.vue';
import OtApi, { executeApi } from '@/services/api.service';
import {
  AconexInteractionStatus,
  GetSearchAconexDocumentsResponseDocumentModel as ApiGetSearchAconexDocumentsResponseDocumentModel,
  GetSearchAconexMailResponseRecipientModel as ApiGetSearchAconexMailResponseRecipientModel,
  GetSearchAconexMailResponseUserModel as ApiGetSearchAconexMailResponseUserModel,
} from '@/services/generated/api';
import { vxm } from '@/store';
import { getAconexDocumentLink } from '@/utils/aconex-utils';
import { formatDateAndTime } from '@/utils/date-utils';
import { Component, Prop, Vue } from 'vue-property-decorator';

type SelectableItem = {
  key: string;
  item: ApiGetSearchAconexDocumentsResponseDocumentModel; // some kind of aconex data type
};

@Component({
  components: {
    OtTableHeader,
    OtTable,
    OtLoadingSpinner,
    OtRadioGroup,
    OtButton,
  },
})
export default class OtAconexMailList extends Vue {
  // * PROPS
  @Prop({ required: true }) private aconexProjectId!: string;

  // * REFS

  // * DATA
  /* from API17061 GET Search Aconex Mail, fields available for sorting are
    * approved 
    * asBuiltRequired 
    * attribute1 
    * attribute2 
    * attribute3 
    * attribute4 
    * author 
    * authorisedBy 
    * category 
    * check1 
    * check2 
    * confidential 
    * contractDeliverable 
    * contractnumber 
    * contractordocumentnumber 
    * contractorrev 
    * date1 
    * date2 
    * docno 
    * doctype 
    * fileSize 
    * fileType 
    * forreview 
    * markupLastModifiedDate 
    * milestonedate 
    * numberOfMarkups 
    * packageNumber 
    * percentComplete 
    * plannedsubmissiondate 
    * printSize 
    * received 
    * reference 
    * registered 
    * reviewed 
    * reviewSource 
    * reviewstatus 
    * revision 
    * revisiondate 
    * scale 
    * statusid 
    * tagNumber 
    * toclient 
    * trackingid 
    * vdrcode 
    * vendorrev
    So, that's what we're setting the keys to. If it's sortable, the key is from above. If it's not sortable, the key doesn't matter.
  */
  private tableColumnsBase: IColumnData[] = [
    {
      index: 0,
      label: '',
      key: 'selectorColumn',
      isActive: false,
      ascending: false,
      sortable: false,
    },
    {
      index: 1,
      label: 'Document No',
      key: 'docno', // don't change this, the API expects this exact string for the sorting
      isActive: true,
      ascending: true,
      sortable: true,
    },
    {
      index: 2,
      label: 'Title',
      key: 'title', // Oddly, this is not sortable. The field is called "title" but the Aconex API rejects it as a sort field.
      isActive: false,
      ascending: false,
      sortable: false,
    },
    {
      index: 3,
      label: 'Revision',
      key: 'revision', // Don't change this, the API expects this exact string for the sorting
      isActive: false,
      ascending: false,
      sortable: true,
    },
    {
      index: 4,
      label: 'Version',
      key: 'versionNumber', // Not sortable
      isActive: false,
      ascending: false,
      sortable: false,
    },
    {
      index: 5,
      label: 'Status',
      key: 'statusid', // Don't change this, the API expects this exact string for the sorting
      isActive: false,
      ascending: false,
      sortable: true,
    },
    {
      index: 6,
      label: 'Created By',
      key: 'author', // Don't change this, the API expects this exact string for the sorting
      isActive: false,
      ascending: false,
      sortable: true,
    },
    {
      index: 7,
      label: 'Date Modified',
      key: 'revisiondate', // Don't change this, the API expects this exact string for the sorting
      isActive: false,
      ascending: false,
      sortable: true,
    },
  ];
  private tableColumns: IColumnData[] = [...this.tableColumnsBase];
  private activeColumn = this.tableColumnsBase[1];
  private page = 1;
  private listItems: SelectableItem[] = [];
  private totalPages = 1;
  private api = new OtApi();

  // * COMPUTED
  private searchTextPrivate = '';
  private get searchText() {
    return this.searchTextPrivate;
  }
  private set searchText(value: string) {
    this.searchTextPrivate = value;
    // back to the first page
    this.updateCurrentPage(1);
  }
  private get aconexLink() {
    // in theory this could be undefined, so we have the fallback. But, if you're in the middle of an import, it better well not be
    return (
      vxm.userProfile.userProfile?.aconexUserInformation?.userSite ||
      'https://constructionandengineering.oraclecloud.com/web/home'
    );
  }

  // * WATCHERS

  // * METHODS
  private updateCurrentPage(value: number) {
    // clear the selected item
    // we could try and keep it, but it doesn't seem to work at first glance. This way it'll be predictable
    this.setSelectedKey('');

    // reload the new page of results
    this.page = value;
    this.loadResults();
  }

  private headerClick(header: IColumnData) {
    const handledHeaders = handleHeaderClick(this.tableColumns, this.activeColumn, header);
    this.tableColumns = handledHeaders.tableColumns;
    this.activeColumn = handledHeaders.activeColumn;
    // go back to the first page
    this.updateCurrentPage(1);
  }

  private isLoading = false;
  private mostRecentLoadKey: symbol | null = null;
  private searchDebounceTimeout: number | null = null;

  // This is not awaitable. There's debouncing and I can't brain how to return a promise when there is debouncing
  // for now, we don't need to await it. If we ever did need to await it, consinder returning a promise and resolving
  // it when the debounce timeout fires. Or something. I don't know this morning, I'm not googling, we don't need it yet
  // implement it later if we need it
  private async loadResults() {
    if (this.searchDebounceTimeout) {
      clearTimeout(this.searchDebounceTimeout);
      this.searchDebounceTimeout = null;
    }
    this.searchDebounceTimeout = setTimeout(this.loadResultsInner, 500);
  }

  private async loadResultsInner() {
    this.isLoading = true;

    let searchQuery = '';
    if (this.searchText) {
      // we're going to split on spaces, then craft the lucene query
      // if the user types in "foo bar" we want to search for "foo*" AND "bar*"
      // if the user types in "foo" we want to search for "foo*"
      // if the user types in "foo bar baz" we want to search for "foo*" AND "bar*" AND "baz*"
      // we need to search across a few fields
      // the finished string should look a bit like
      // title:(Dev* AND Gui*) OR docno:(Dev* AND Gui*) OR author:(Dev* AND Gui*)
      // for a single word, it'll be overkill with the brackets, but it'll work

      const rawSearchTerms = this.searchText.split(' ');
      const processedSearchTerms = rawSearchTerms.map(x => `${x}*`);
      const processedSearchTermsString = processedSearchTerms.join(' AND ');

      searchQuery = `docno:(${processedSearchTermsString}) OR title:(${processedSearchTermsString}) OR author:(${processedSearchTermsString})`;
      // searchQuery = `title:${processedSearchText}`;
    }
    // the key is optional and not needed, but I feel like it's nice to give it a description
    const thisRequestLoadKey = Symbol('get-search-documents');
    this.mostRecentLoadKey = thisRequestLoadKey;

    const apiResult = await executeApi(
      () =>
        this.api.aconex().getSearchAconexDocuments(
          // @param projectId Aconex Project Id originally obtained from call to <seealso cref="M:OneTrack.Api.V1.AconexController.GetAconexProjects(OneTrack.Api.Commands.Aconex.IGetAconexProjectsCommand,System.Threading.CancellationToken)">API17056 - GET Aconex Projects</seealso>
          this.aconexProjectId,
          // @param query (optional) Lucene search query.
          // Without a search_query, every document in the project is returned.
          // If search query only contains Lucence Single Terms (separated by spaces), a "*" will be automatically appended to each term to do a wildcard search. See more in Apache Lucene - Query Parser Syntax .
          // Please refer to the notes below for further information about Lucene.
          // Field names available for searching are:
          // <list type="bullet"><item>approved </item><item>asBuiltRequired </item><item>attribute </item><item>secondaryattribute </item><item>attribute3 </item><item>attribute4 </item><item>author </item><item>category </item><item>contractnumber </item><item>contractordocumentnumber </item><item>contractorrev </item><item>date1 </item><item>date2 </item><item>discipline </item><item>docno </item><item>doctype </item><item>forreview </item><item>markupdate </item><item>milestonedate </item><item>packagenumber </item><item>plannedsubmissiondate </item><item>received </item><item>reference </item><item>registered </item><item>reviewed </item><item>reviewstatus </item><item>revision </item><item>revisiondate </item><item>scale </item><item>selectlist1 </item><item>selectlist2 </item><item>selectlist3 </item><item>selectlist4 </item><item>selectlist5 </item><item>selectlist6 </item><item>selectlist7 </item><item>selectlist8 </item><item>selectlist9 </item><item>selectlist10 </item><item>statusid </item><item>title </item><item>toclient </item><item>trackingid </item><item>uploaddate </item><item>vdrcode </item><item>vendordocumentnumber </item><item>vendorrev </item></list>
          searchQuery,
          // @param pageSize (optional) If specified, the value must be a number that is divisible by 25. Without this parameter specified, this defaults to 25.
          // Note: This parameter has a maximum value of 500
          25,
          // @param pageNumber (optional) If specified, the value must be between "1" and the value of the "TotalPages" attribute that is in the response, otherwise an error is returned. Without this parameter specified, this defaults to 1.
          this.page,
          // @param sortField (optional) The name of the field to sort the search results by. Results can only be sorted by a single field, although it does not have to be one of the fields specified in the return_fields parameter.
          // Field names available for sorting are:
          // <list type="bullet"><item>approved </item><item>asBuiltRequired </item><item>attribute1 </item><item>attribute2 </item><item>attribute3 </item><item>attribute4 </item><item>author </item><item>authorisedBy </item><item>category </item><item>check1 </item><item>check2 </item><item>confidential </item><item>contractDeliverable </item><item>contractnumber </item><item>contractordocumentnumber </item><item>contractorrev </item><item>date1 </item><item>date2 </item><item>docno </item><item>doctype </item><item>fileSize </item><item>fileType </item><item>forreview </item><item>markupLastModifiedDate </item><item>milestonedate </item><item>numberOfMarkups </item><item>packageNumber </item><item>percentComplete </item><item>plannedsubmissiondate </item><item>printSize </item><item>received </item><item>reference </item><item>registered </item><item>reviewed </item><item>reviewSource </item><item>reviewstatus </item><item>revision </item><item>revisiondate </item><item>scale </item><item>statusid </item><item>tagNumber </item><item>toclient </item><item>trackingid </item><item>vdrcode </item><item>vendorrev </item></list>
          this.activeColumn.sortable ? this.activeColumn.key : undefined,
          // @param sortDirection (optional) One of:
          // <list type="bullet"><item>ASC, ascending order </item><item>DESC, descending order </item></list>
          // Note: Without this parameter specified, sort defaults to ASC.
          this.activeColumn.sortable ? (this.activeColumn.ascending ? 'ASC' : 'DESC') : undefined,
        ),
      'Searching Aconex Documents',
    );
    if (this.mostRecentLoadKey !== thisRequestLoadKey) {
      // Another request has been made - the module level variable has been set to something else
      // Drop these results on the floor
      // Don't worry about setting isLoading either, we know there is another request happening
      return;
    }

    if (apiResult.success) {
      if (apiResult.data && apiResult.data.aconexInteractionStatus === AconexInteractionStatus.Success) {
        this.listItems =
          apiResult.data.result?.searchResults.map(x => ({
            key: x.documentId,
            isSelected: false,
            item: x,
          })) ?? [];
        this.totalPages = apiResult.data.result?.totalPages ?? 1;
      } else {
        console.warn('Aconex Mail Search Failed', apiResult.data);
        this.listItems = [];
      }
    }

    this.isLoading = false;
  }

  private displayUser(user: ApiGetSearchAconexMailResponseUserModel) {
    return `${user.firstName} ${user.lastName} (${user.organizationName})`;
  }
  private displayUsers(users: ApiGetSearchAconexMailResponseRecipientModel[]) {
    // could also use a line break. This is more compact, hard to read though
    // Could bust these out by the TO CC BCC as well
    return users.map(u => `${u.distributionType}: ${this.displayUser(u)}`).join(',');
  }
  private formatDateAndTime(date: Date) {
    return formatDateAndTime(date);
  }
  private selectedKey = '';
  private setSelectedKey(key: string) {
    this.selectedKey = key;
    if (key) {
      const selectedItem = this.listItems.find(x => x.key === key);
      if (selectedItem) {
        this.$emit('select', selectedItem.item);
      } else {
        console.warn('ot-aconex-mail-list: setSelectedKey: selectedItem not found', { items: this.listItems, key });
      }
    } else {
      this.$emit('select', null);
    }
  }

  private getAconexDocumentLink(doc: ApiGetSearchAconexDocumentsResponseDocumentModel) {
    return getAconexDocumentLink({
      documentId: doc.documentId,
      projectId: this.aconexProjectId,
      // we are doing the import, so we know what site it is for. It's not on the search results yet
      originalAconexSite: vxm.userProfile.userProfile?.aconexUserInformation?.userSite ?? null,
    });
  }

  // * LIFECYCLE
  private async mounted() {
    console.log('ot-aconex-document-list: mounted');
    this.loadResultsInner();
  }
}
